import Configuration from "../config";

export function initAnalytics() {
  // Dynamically load google analytics if necessary.
  const analyticsId = Configuration.GOOGLE_ANALYTICS_ID;
  if (!!analyticsId) {
    // Global Site Tag (gtag.js) - Google Analytics
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
    document.head.appendChild(script);

    const anyWindow = window as any;

    anyWindow.dataLayer = anyWindow.dataLayer || [];
    anyWindow.gtag = function gtag() {
      anyWindow.dataLayer.push(arguments);
    } as any;

    anyWindow.gtag("js", new Date());
    anyWindow.gtag("config", analyticsId);
  }
}

export function trackEvent(name: string, params: any) {
  if ((window as any)?.gtag) {
    (window as any)?.gtag("event", name, params);
  }
}

export function trackSignIn(userId: string) {
  trackEvent("login", { user_id: userId });
}

export function trackSignUp(userId: string) {
  trackEvent("signup", { user_id: userId });
}

export function trackPurchase(
  userId: string,
  type: "subscription" | "lessons",
  isCorporate: boolean,
  location: "onboarding" | "settings"
) {
  trackEvent("purchase", {
    purchase_type: type,
    corporate_user_purchase: isCorporate,
    user_id: userId,
    purchase_location: location,
  });
}

export function trackUserId(userId: string) {
  const gtag = (window as any)?.gtag;
  // TODO: move it to the config
  gtag && gtag("config", "G-T9MGM0LE0K", { user_id: userId });
}
